import { Button, Menu } from 'antd';
import { observer } from 'mobx-react';
import React, { Component } from 'react';
import { Link, Navigate, Outlet } from 'react-router-dom';
import { IRootStoreProps, WithoutStore, withStore } from '../../stores';
import { ContentWrapp } from '../common';
import { UserRoleEnum } from '../user';
import routesConfig from '../../config/routes';
import { Content, Header } from 'antd/es/layout/layout';
import { HomeOutlined } from '@ant-design/icons';

class _ConsoleLayout extends Component<IRootStoreProps> {
  render(): React.ReactNode {
    const { user, console } = this.props.store;

    if (!user.isAuth || !user.data?.roles?.includes(UserRoleEnum.ADMIN)) {
      return <Navigate to={routesConfig.home} />;
    }

    const items = [
      {
        key: routesConfig.consoleUsers,
        label: 'Пользователи',
      },
      {
        key: routesConfig.consoleNews,
        label: 'Новости',
      },
    ];

    return (
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          minHeight: '100vh',
        }}
      >
        <ContentWrapp style={{ flex: 1 }}>
          <Header style={{ display: 'flex', alignItems: 'center' }}>
            <Link to={routesConfig.home}>
              <Button type={'primary'} icon={<HomeOutlined />} style={{ marginRight: 20 }} />
            </Link>
            <Menu
              theme="dark"
              mode="horizontal"
              defaultSelectedKeys={[routesConfig.consoleUsers]}
              items={items}
              style={{ flex: 1, minWidth: 0 }}
              onClick={console.setMenu}
            />
          </Header>
          <Content style={{ paddingTop: 20 }}>
            <Outlet />
          </Content>
        </ContentWrapp>
      </div>
    );
  }
}

export const ConsoleLayout: WithoutStore = withStore(observer(_ConsoleLayout));
